import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

// let healthbarsprite = HealthBar(unit.key, health, unit.maxhealth, {"x": 0, "y": 0, "z": 0}, unit.affiliation, unitFornextTurnHealth)
import Colors from "@frog/source/data/colors.js"
import {colortween} from "@frog/source/juice/utility/Tweens.js"
import Loop from "@frog/source/utility/Loop.js"
import Random from "@frog/source/utility/Random.js"

import Text from "@frog/source/views/Text.view.js"

export default function HealthBar(stage, unit) {
    if(unit.opacity != undefined) return

    // // Rendering the unit position as
    // // the future state of the actions.
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage[unit.key] != undefined) {
    //     unit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    // }
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.activeUnit != undefined
    // && App.game.encounter.selection.activeUnit.affiliation == "bad"
    // && stage.nextTurn != undefined
    // && stage.nextTurn.omegastage != undefine
    // && stage.nextTurn.omegastage.units[unit.key] != undefined) {
    //     unit = stage.nextTurn.omegastage.units[unit.key]
    //     // TODO: This is showing the entire enemy turn omegastage
    //     // instead of just what damage will be performed by this
    //     // hovered enemy unit. Can we get that granular?
    // }
    // THIS RENDERS JUST THE NEXT ACTION'S OUTCOME
    // if(Director.isPerforming != true
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
    //     unitFornextTurnHealth = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    // }
    // THIS RENDERS THE NEXT TURN'S HEALTH OUTCOME, BUT
    // CURRENTLY RENDERS IT LIKE IT IS THE ACTUAL HEALTH
    let nextTurnUnit = undefined
    let nextAction = undefined
    let nextActionUnit = undefined
    if(Director.isPerforming != true
    && stage.nextTurn != undefined
    && stage.nextTurn.omegastage != undefined
    && stage.nextTurn.omegastage.units[unit.key] != undefined) {
        // nextTurnUnit = stage.nextTurn.omegastage.units[unit.key]
    }
    // if(Director.isPerforming != true // IGNORE DIRECTOR
    // && App.game.encounter != undefined
    // && App.game.encounter.selection != undefined
    // && App.game.encounter.selection.hoveredAction != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.nextTurn != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units != undefined
    // && App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key] != undefined) {
    //     // nextTurnUnit = App.game.encounter.selection.hoveredAction.omegastage.nextTurn.omegastage.units[unit.key]
    //     nextActionUnit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    // }
    if(App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.omegastage != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.units != undefined
    && App.game.encounter.selection.hoveredAction.omegastage.units[unit.key] != undefined) {
        nextAction = App.game.encounter.selection.hoveredAction
        nextActionUnit = App.game.encounter.selection.hoveredAction.omegastage.units[unit.key]
    }
    // if(Director.isPerforming == true) {
    //     // nextTurnUnit = App.game.encounter.stage.nextTurn.omegastage.units[unit.key]
    //     nextActionUnit = App.game.encounter.stage.units[unit.key]
    // }

    let isDead = false
    if(nextActionUnit != undefined
    && nextActionUnit.isDead == true) {
        isDead = true
    }
    if(nextTurnUnit != undefined
    && nextTurnUnit.isDead == true) {
        isDead = true
    }

    let flourishTexts = []
    if(nextAction != undefined) {
        // THIS ONLY SUPPORTS DELTASTAGES v2? FOR UNIT SCHEMA
        // SHOULD DELTA.JS MODIFY THE DELTASTAGE TO UNIFY IT FROM
        // SYNTACTIC SUGAR IN THE SKILLS? OH, I THINK IT DOES,
        // WITH A STAGE.UNIT. IT ISN'T STAGE.UNITS STILL, BUT W/E
        nextAction.steps.forEach((step) => {
            if(step.deltastages != undefined) {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage.flourish != undefined
                    && deltastage.flourish.name == "TextFloat"
                    && deltastage.flourish.type == "damage" // REQUIRES THE FLOURISH HAVE ADDITIONAL TYPE AND UNITKEY
                    && deltastage.flourish.unitKey == unit.key) {
                        flourishTexts.push(deltastage.flourish.text)
                    }
                })
            }
        })
        // damage = nextActionUnit.health - unit.health
    }

    return {
        "width": "100%",
        "height": "100%",
        // "color": "orange",
        "_": [
            // PercentageHealthBar({unit, nextTurnUnit, nextActionUnit}),
            ChunkyHealthBar({
                unit, nextTurnUnit, nextActionUnit, nextTurnUnit,
                "property": "health",
                // "position": {"x": 8, "y": -5}
                "position": {"x": 0, "y": 0}
            }),
            // {
            //     // "width": 8,
            //     // "height": 3,
            //     // "color": Colors.black,
            //     "_": [
            //         {
            //             // "width": 8-2,
            //             // "height": 3-2,
            //             // "position": {"x": 1, "y": 1},
            //         }
            //     ]
            // },

            // Bar({"property": "health", unit, nextTurnUnit, nextActionUnit}),

            unit.maxarmor > 0 && ChunkyHealthBar({
                unit, nextTurnUnit, nextActionUnit,
                "property": "armor",
                "maxproperty": "maxarmor",
                "position": {"x": unit.maxhealth * 3, "y": 0},
                "colors": {"filled": unit.armortype == "mana" ? Colors.blue : "gray"}
            }),

            // isDead && {
            //     "position": {"stack": 10, "x": 4 + Random.range(-1, 1), "y": -4 + Random.range(-1, 1)},
            //     "image": require("@frog/source/assets/images/hero-tactics/ui/death.png").default,
            // }

            // flourishTexts.length > 0 && {
            //     "position": {"x": 8, "y": -2},
            //     "anchor": {"x": "50%", "y": "100%"},
            //     // "stack": 99999,
            //     "_": flourishTexts.map((flourishText) => {
            //         return Text({
            //             "text": flourishText,
            //             "font": "numbers", // NOTE WELL! THE FONT IS NUMBERS ONLY, REGARDLESS OF THE TEXT!!
            //         })
            //     })
            // },
        ].filter((child) => !!child)
    }
}

import PercentageHealthBar from "@frog/source/views/PercentageHealthBar.view.js"

const SPACING = 1
function ChunkyHealthBar({property = "health", maxproperty = "maxhealth", unit, nextTurnUnit = {}, nextActionUnit = {}, position, colors}) {
    colors = colors || {}
    colors.filled = colors.filled || "#38c798" // Colors.red
    colors.empty = colors.empty || "#fbfbe8" // Colors.white
    colors.threatened = colors.threatened || "#ffc848" // "#f0ea94" // Colors.yellow
    colors.background = colors.background || "#362e3f" // || Colors.black || "#000"
    // colors.threatened = Colors.red // FOR ANIMATION DEBUGGING

    const sprites = []
    const WIDTH = 2
    let HEIGHT = 3
    // if(unit.key == App.game.encounter.selection.hoveredUnitKey
    // || unit.key == App.game.encounter.selection.selectedUnitKey) {
    //     HEIGHT = 2
    // }
    const GAP = 1
    for(let i = 0; i < unit["max" + property]; i += 1) {
        const x = i * WIDTH

        if(i != 0) {
            sprites.push({
                "key": "health/" + i + "/gap",
                "anchor": {"x": 0, "y": 0},
                // "position": {"x": x * SPACING, "y": 0, "stack": 0},
                "type": "rectangle",
                "color": colors.background,
                "width": SPACING,
                "height": HEIGHT,
            })
        }

        // TODO: this is busted by the colors not being in hex values already?
        // colors.threatened2 = colors.threatened
        colors.threatened2 = colortween(colors.empty, colors.threatened, ((Loop.time.ms % 500) / 500), "hexstring")
        // if(Director.isPerforming != true) {
        // }
        if(nextActionUnit != undefined
        && nextActionUnit[property] > unit[property]
        && i >= unit[property]
        && i < nextActionUnit[property]) {
            sprites.push({
                "key": "health/" + i + "/nextAction",
                "anchor": {"x": 0, "y": 0},
                // "position": {"x": x * SPACING, "y": 0, "stack": 2},
                // "position": {"x": x, "y": (Math.floor(Math.random() * 2) - 1), "stack": 0},
                "type": "rectangle",
                "color": colors.threatened2 ?? colors.threatened,
                "width": WIDTH,
                "height": HEIGHT,
            })
            continue
        }
        if(nextActionUnit != undefined
        && nextActionUnit[property] < unit[property]
        && i < unit[property]
        && i >= nextActionUnit[property]) {
            sprites.push({
                "key": "health/" + i + "/nextAction",
                "anchor": {"x": 0, "y": 0},
                // "position": {"x": x * SPACING, "y": 0, "stack": 2},
                // "position": {"x": x, "y": (Math.floor(Math.random() * 2) - 1), "stack": 0},
                "type": "rectangle",
                "color": colors.threatened2 ?? colors.threatened,
                "width": WIDTH,
                "height": HEIGHT,
            })
            continue
        }

        // // if(Director.isPerforming != true) {
        // const nextHealth = Math.max(nextTurnUnit[property], unit[property]) || unit[property]
        // if(nextTurnUnit[property] > nextHealth
        // && i >= nextHealth
        // && i < nextTurnUnit[property]) {
        //     sprites.push({
        //         "key": "health/" + i + "/nextTurn",
        //         "anchor": {"x": 0, "y": 0},
        //         "position": {"x": x * SPACING, "y": 0, "stack": 1},
        //         // "position": {"x": x, "y": (Math.floor(Math.random() * 2) - 1), "stack": 0},
        //         "type": "rectangle",
        //         "color": colors.threatened,
        //         "width": WIDTH,
        //         "height": HEIGHT,
        //     })
        // }
        // if(nextTurnUnit[property] < nextHealth
        // && i < nextHealth
        // && i >= nextTurnUnit[property]) {
        //     sprites.push({
        //         "key": "health/" + i + "/nextTurn",
        //         "anchor": {"x": 0, "y": 0},
        //         "position": {"x": x * SPACING, "y": 0, "stack": 1},
        //         // "position": {"x": x, "y": (Math.floor(Math.random() * 2) - 1), "stack": 0},
        //         "type": "rectangle",
        //         "color": colors.threatened,
        //         "width": WIDTH,
        //         "height": HEIGHT,
        //     })
        // }
        // // }

        if(i < unit[property]) {
            sprites.push({
                "key": "health/" + i,
                "anchor": {"x": 0, "y": 0},
                // "position": {"x": x * SPACING, "y": 0, "stack": 0},
                "type": "rectangle",
                "color": colors.filled, // TODO: color differently for allies
                "width": WIDTH,
                "height": HEIGHT,
            })
            continue
        }

        sprites.push({
            "key": "health/" + i,
            "anchor": {"x": 0, "y": 0},
            // "position": {"x": x * SPACING, "y": 0, "stack": 0},
            "type": "rectangle",
            "color": colors.empty,
            "width": WIDTH,
            "height": HEIGHT,
        })
    }

    const OUTLINE_SIZE = 1
    sprites.unshift({
        "key": "background",
        "anchor": {"x": 0, "y": 0},
        "position": {
            "x": -1 * OUTLINE_SIZE,
            "y": -1 * OUTLINE_SIZE,
            "stack": -2
        },
        "type": "rectangle",
        "color": Colors.black || "#000",
        "height": HEIGHT + OUTLINE_SIZE + OUTLINE_SIZE,
        "width": OUTLINE_SIZE + (unit[maxproperty] * (WIDTH + SPACING))
    })

    return {
        "key": "bar" + "/" + property,
        "_": sprites,
        // "anchor": {"x": "50%"},
        // "width": OUTLINE_SIZE + (unit[maxproperty] * (WIDTH + SPACING)),
        "position": position,
    }
}
